import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

const Academic = () => {
    // Initialize AOS
    useEffect(() => {
        AOS.init({
            duration: 1000,
            once: false,
            offset: 100,
            easing: 'ease-out-cubic',
        });
    }, []);

    return (
        <>
            {/* Page Header Start */}
            <div className="container-fluid page-header py-5" style={{ marginBottom: "6rem" }} data-aos="fade-down">
                <div className="container py-5">
                    <h1 className="display-3 text-white mb-3">Academic Education</h1>
                </div>
            </div>
            {/* Page Header End */}

            {/* Introduction Section */}
            <div className="container-xxl py-5">
                <div className="container">
                    <div className="row g-5 align-items-center">
                        <div className="col-lg-6" data-aos="fade-right" data-aos-delay="100">
                            <div className="position-relative text-center">
                                <img src="img/academic-1.jpg" className="img-fluid rounded shadow-lg w-100" alt="Academic Education Partnership" style={{ maxHeight: "400px", objectFit: "cover" }} />
                            </div>
                        </div>

                        <div className="col-lg-6" data-aos="fade-left" data-aos-delay="100">
                            <h6 className="text-primary text-uppercase mb-2">Academic Partnerships</h6>
                            <h1 className="display-6 mb-4">Comprehensive Academic Education Services</h1>
                            <p className="mb-4">A2Z Solutions is proud to partner with leading universities to provide quality academic education, skill development, and professional training programs. Our collaborations with esteemed institutions like Sikkim Skill University and The University of Trans-Disciplinary Health Sciences and Technology (TDU) enable us to offer accredited educational programs.</p>

                            <p className="mb-4">We bridge the gap between academia and industry by providing practical, skill-oriented education that prepares students and professionals for real-world challenges. Our programs are designed to meet the evolving needs of the job market while maintaining academic excellence.</p>

                            <div className="row g-3">
                                <div className="col-sm-6" data-aos="fade-up" data-aos-delay="200">
                                    <div className="d-flex">
                                        <i className="fa fa-graduation-cap text-primary fa-2x flex-shrink-0 me-3"></i>
                                        <div>
                                            <h5 className="mb-1">University Partnerships</h5>
                                            <p className="mb-0">Accredited academic programs</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-6" data-aos="fade-up" data-aos-delay="300">
                                    <div className="d-flex">
                                        <i className="fa fa-users text-primary fa-2x flex-shrink-0 me-3"></i>
                                        <div>
                                            <h5 className="mb-1">Skill Development</h5>
                                            <p className="mb-0">Industry-relevant training</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* University Partnerships Section */}
            <div className="container-xxl py-5 bg-light">
                <div className="container">
                    <div className="text-center mb-5" data-aos="fade-up" data-aos-delay="100">
                        <h6 className="text-primary text-uppercase">Our Academic Partners</h6>
                        <h1 className="display-6 mb-4">Collaborations with Leading Universities</h1>
                    </div>

                    <div className="row g-5">
                        {/* Sikkim Skill University Collaboration */}
                        <div className="col-lg-6" data-aos="fade-right" data-aos-delay="150">
                            <div className="bg-white p-4 rounded shadow h-100">
                                <h3 className="mb-3 text-primary">Partnership with Sikkim Skill University</h3>
                                <p className="mb-4">A2Z Solutions is proud to be an <strong>Academic Programme Partner</strong> with Sikkim Skill University, established under section 2(f) of UGC Act, 1956. This prestigious partnership enables us to offer certified skill development programs with national recognition.</p>
                                
                                <div className="mb-4">
                                    <h5 className="mb-2">Our Collaboration Details:</h5>
                                    <ul className="list-unstyled">
                                        <li className="mb-2"><i className="fa fa-check text-primary me-2"></i> Registered Academic Programme Partner</li>
                                        <li className="mb-2"><i className="fa fa-check text-primary me-2"></i> UGC-recognized certification</li>
                                        <li className="mb-2"><i className="fa fa-check text-primary me-2"></i> Skill-based training programs</li>
                                        <li className="mb-2"><i className="fa fa-check text-primary me-2"></i> Industry-aligned curriculum</li>
                                        <li className="mb-2"><i className="fa fa-check text-primary me-2"></i> Nationally recognized qualifications</li>
                                    </ul>
                                </div>

                                <div className="text-center mt-4">
                                    <img 
                                        src="img/sikkim-certificate.png" 
                                        className="img-fluid rounded shadow" 
                                        alt="Sikkim Skill University Partnership Certificate"
                                        style={{ maxHeight: "800px", objectFit: "contain", border: "1px solid #ddd" }}
                                    />
                                    <p className="text-muted mt-2 mb-0"><small>Official Academic Programme Partner Certificate</small></p>
                                </div>
                            </div>
                        </div>

                        {/* TDU University Collaboration */}
                        <div className="col-lg-6" data-aos="fade-left" data-aos-delay="150">
                            <div className="bg-white p-4 rounded shadow h-100">
                                <h3 className="mb-3 text-primary">Collaboration with TDU University</h3>
                                
                                {/* TDU Image/Logo Section */}
                                <div className="text-center mb-4">
                                    <div className="d-inline-block border rounded p-3 mb-3" 
                                        style={{ backgroundColor: "#f8f9fa", maxWidth: "600px" }}>
                                        <img 
                                            src="img/tdu-image.jpg" 
                                            className="img-fluid" 
                                            alt="TDU University Logo"
                                            style={{ maxHeight: "500px", objectFit: "contain" }}
                                        />
                                    </div>
                                </div>
                                
                                <p className="mb-4">We partner with <strong>The University of Trans-Disciplinary Health Sciences and Technology (TDU)</strong>, a premier institution in Bengaluru known for its excellence in transdisciplinary research and education.</p>
                                
                                <div className="mb-4">
                                    <h5 className="mb-2">About TDU University:</h5>
                                    <p className="mb-3">TDU excels in research and education in integrative health sciences and technology, bridging traditional wisdom with cutting-edge science, and fostering a unique ecosystem.</p>
                                    
                                    <p className="mb-3">As one of the best research universities in Bengaluru, TDU's core strength lies in integrating Ayurveda with modern Biology into a new area of research known as Ayurveda Biology.</p>
                                </div>

                                <div className="mb-4">
                                    <h5 className="mb-2">Research Areas Include:</h5>
                                    <ul className="list-unstyled">
                                        <li className="mb-2"><i className="fa fa-flask text-primary me-2"></i> Ayurveda Biology and Integrative Medicine</li>
                                        <li className="mb-2"><i className="fa fa-heartbeat text-primary me-2"></i> Clinical Medicine and Healthcare Research</li>
                                        <li className="mb-2"><i className="fa fa-leaf text-primary me-2"></i> Medicinal Plants Systematics and Genomics</li>
                                        <li className="mb-2"><i className="fa fa-database text-primary me-2"></i> Data Sciences and Traditional Knowledge Informatics</li>
                                        <li className="mb-2"><i className="fa fa-book text-primary me-2"></i> Manuscriptology and Theoretical Foundations</li>
                                        <li className="mb-2"><i className="fa fa-globe text-primary me-2"></i> Local Health Traditions and Ethnomedicine</li>
                                    </ul>
                                </div>

                                <div className="bg-primary-light p-3 rounded">
                                    <p className="mb-0"><strong>Our Partnership Focus:</strong> Developing joint programs in healthcare education, research methodology, and integrative medicine that combine traditional knowledge with modern scientific approaches.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Academic Services Content Section */}
            <div className="container-xxl py-5">
                <div className="container">
                    <div className="row g-5">
                        <div className="col-lg-12">
                            <h2 className="mb-4" data-aos="fade-up" data-aos-delay="100">Our Academic Education Services</h2>

                            <p className="mb-4" data-aos="fade-up" data-aos-delay="150">A2Z Solutions provides comprehensive academic services through our university partnerships, offering both traditional and innovative educational programs that cater to diverse learning needs and career aspirations.</p>

                            <h4 className="mb-3" data-aos="fade-up" data-aos-delay="200">Certified Skill Development Programs</h4>
                            <p className="mb-4" data-aos="fade-up" data-aos-delay="250">Through our partnership with Sikkim Skill University, we offer UGC-recognized certification programs in various skill domains. These programs are designed to enhance employability and provide industry-relevant skills with proper academic credentials and recognition.</p>

                            <h4 className="mb-3" data-aos="fade-up" data-aos-delay="300">Professional Training and Workshops</h4>
                            <p className="mb-4" data-aos="fade-up" data-aos-delay="350">We conduct professional training sessions, workshops, and seminars in collaboration with university faculty and industry experts. These programs focus on practical skills, current industry trends, and professional development across various sectors.</p>

                            <h4 className="mb-3" data-aos="fade-up" data-aos-delay="400">Curriculum Development and Design</h4>
                            <p className="mb-4" data-aos="fade-up" data-aos-delay="450">Our team collaborates with academic partners to design and develop curriculum that balances theoretical knowledge with practical application. We ensure our programs meet academic standards while addressing industry requirements and technological advancements.</p>

                            <div className="text-center my-5" data-aos="zoom-in" data-aos-delay="500">
                                <img src="img/academic-2.jpeg" className="img-fluid rounded shadow-lg w-75" alt="Academic Training Session" style={{ maxHeight: "450px", objectFit: "cover" }} />
                            </div>

                            <h4 className="mb-3" data-aos="fade-up" data-aos-delay="550">Online and Blended Learning Programs</h4>
                            <p className="mb-4" data-aos="fade-up" data-aos-delay="600">We offer flexible learning options through online and blended programs that allow students to learn at their own pace while receiving quality education from recognized institutions. Our digital learning platforms provide interactive content, assessments, and support.</p>

                            <h4 className="mb-3" data-aos="fade-up" data-aos-delay="650">Research and Development Initiatives</h4>
                            <p className="mb-4" data-aos="fade-up" data-aos-delay="700">In collaboration with TDU University, we support research initiatives in trans-disciplinary areas, particularly in health sciences, traditional medicine, and integrative healthcare approaches. We facilitate research partnerships and knowledge exchange.</p>

                            <h4 className="mb-3" data-aos="fade-up" data-aos-delay="750">Industry-Academia Bridge Programs</h4>
                            <p className="mb-4" data-aos="fade-up" data-aos-delay="800">We create pathways for students and professionals to connect with industry through internships, industrial visits, guest lectures, and collaborative projects. These programs enhance practical understanding and improve job readiness.</p>

                            <h2 className="mb-4 mt-5" data-aos="fade-up" data-aos-delay="850">Program Offerings</h2>

                            <div className="row g-4">
                                <div className="col-md-6" data-aos="fade-up" data-aos-delay="900">
                                    <div className="bg-light p-4 rounded h-100">
                                        <h5 className="mb-3">Short-Term Certification Programs</h5>
                                        <ul className="mb-0">
                                            <li className="mb-2">Professional Skill Certifications (3-6 months)</li>
                                            <li className="mb-2">Diploma Programs in Specialized Fields</li>
                                            <li className="mb-2">Industry-Specific Training Modules</li>
                                            <li className="mb-2">Digital Literacy and IT Skills</li>
                                            <li>Soft Skills and Communication Training</li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-md-6" data-aos="fade-up" data-aos-delay="950">
                                    <div className="bg-light p-4 rounded h-100">
                                        <h5 className="mb-3">Academic Research Programs</h5>
                                        <ul className="mb-0">
                                            <li className="mb-2">Research Methodology Workshops</li>
                                            <li className="mb-2">Traditional Medicine Research</li>
                                            <li className="mb-2">Integrative Health Studies</li>
                                            <li className="mb-2">Data Analysis in Healthcare</li>
                                            <li>Academic Writing and Publication Support</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div className="bg-light p-4 rounded mt-5" data-aos="fade-up" data-aos-delay="1200">
                                <h4 className="mb-3">Why Choose A2Z Solutions for Academic Education?</h4>
                                <p className="mb-3">Our partnerships with recognized universities provide credibility and academic rigor to our programs. Students receive certifications that are nationally recognized and respected by employers and educational institutions.</p>

                                <p className="mb-3">We focus on practical, employable skills that align with current industry needs. Our curriculum is regularly updated to reflect technological advancements and market trends, ensuring our students are job-ready.</p>

                                <p className="mb-3">Our experienced faculty and industry experts bring real-world insights to the classroom. The combination of academic knowledge and practical experience creates a rich learning environment.</p>

                                <p className="mb-0">With flexible learning options and supportive learning environments, we cater to diverse student needs. Whether you're a fresh graduate, working professional, or career changer, we have programs designed to help you achieve your educational and career goals.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Contact CTA Section */}
            {/* <div className="container-xxl py-5">
                <div className="container">
                    <div className="bg-light rounded p-5 text-center" data-aos="zoom-in" data-aos-delay="100">
                        <h2 className="mb-3">Start Your Educational Journey Today</h2>
                        <p className="mb-4">Interested in our academic programs or want to know more about our university partnerships?</p>
                        <a href="/contact" className="btn btn-primary py-3 px-5">
                            <i className="fa fa-envelope me-2"></i> Contact Us for Details
                        </a>
                    </div>
                </div>
            </div> */}

            <style jsx>{`
                .page-header {
background: linear-gradient(rgba(6, 3, 21, 0.8), rgba(6, 3, 21, 0.8)), 
                                url('img/carousel-01.jpg') no-repeat center center;
                    background-size: cover;                }                }
            `}</style>
        </>
    );
}

export default Academic;